import { ajaxErrorAlert, ajaxPost } from "./utils";
import { getJsContext } from "../app";

const body = $("body");

function showErrorMessage(message) {
  const errorMessageDiv = $("#errorMessage");
  errorMessageDiv
    .removeClass("d-none")
    .html('<i class="fas fa-times me-2"></i>' + message)
    .fadeIn()
    .delay(8000)
    .fadeOut();
}

function showSuccessMessage(message) {
  const successMessageDiv = $("#successMessage");
  successMessageDiv
    .removeClass("d-none")
    .removeClass("shake")
    .html(
      '<i class="far fa-check-circle me-2"></i>' +
        message +
        '<button type="button" class="btn-close" data-bs-dismiss="alert"></button>',
    )
    .addClass("shake");
}

function resetForms() {
  $("#cascoCalculationForm, #sendCalculationResultForm").each(function () {
    this.reset(); // Reset form fields
  });

  // Optionally reset select elements if using Select2
  $("#cascoCalculationForm select, #sendCalculationResultForm select")
    .val("")
    .trigger("change");
}

if (body.hasClass("casco")) {
  const cascoCalculationForm = $("#cascoCalculationForm");
  const sendCalculationResultForm = $("#sendCalculationResultForm");
  const calculatingResultsDiv = $("#calculatingResults");
  const cascoCalculationButton = $("#cascoCalculationButton");

  cascoCalculationForm.on("change", "input, select", function () {
    cascoCalculationButton.removeClass("d-none");
    sendCalculationResultForm.addClass("d-none");
    calculatingResultsDiv.addClass("d-none");
  });

  cascoCalculationForm.on("submit", function (e) {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();
    data.push({
      name: "action",
      value: "calculate_premium",
    });
    form.loading({
      loadingText: getJsContext("calculation_loading_text"),
      action: "show",
      extraClasses: "spinner-fixed",
    });
    ajaxPost("", data, form)
      .then((response) => {
        $("#insurance_premium").text(response.insurance_premium + " AZN");
        $("#insurance_factor").text(response.casco_rate + " %");
        $("#monthly_amount").text(response.monthly_amount + " AZN");
        $("#calculation_id").val(response.calculation_id);
        calculatingResultsDiv.removeClass("d-none");
        sendCalculationResultForm.removeClass("d-none");
        cascoCalculationButton.addClass("d-none");
        $("html, body").animate(
          {
            scrollTop: sendCalculationResultForm.offset().top,
          },
          600,
        );
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  sendCalculationResultForm.on("submit", function (e) {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();
    data.push({
      name: "action",
      value: "send_request",
    });
    form.loading({
      loadingText: getJsContext("please_wait"),
      action: "show",
      extraClasses: "spinner-fixed",
    });
    ajaxPost("", data, form)
      .then((response) => {
        if (response.success) {
          showSuccessMessage(response.message);
          resetForms();
          $("#sendCalculationResultForm").addClass("d-none");
          $("#calculatingResults").addClass("d-none");
        } else {
          if (response.message) {
            showErrorMessage(response.message);
          } else {
            showErrorMessage(getJsContext("error_please_try_again_later"));
          }
        }
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          600,
        );
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });
}
